import React from 'react';
import { Navigation } from './Navigation';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen flex flex-col bg-gray-50 font-sans" data-id="element-82" data-mp="zxxoiam0ya1m">
      <Navigation data-id="element-83" data-mp="zv1omgqm9baj" />
      <main className="flex-grow" data-id="element-84" data-mp="uyksaz99jqmd">{children}</main>
      <Footer data-id="element-85" data-mp="uyukmths69v8" />
    </div>;
}